import type { SxProps, Theme } from "@mui/material/styles";

export const grid: SxProps<Theme> = (theme) => ({
  display: "grid",
  gridTemplateColumns: { xs: "repeat(2, 1fr)", md: "repeat(4, 1fr)" },
  gap: { xs: theme.spacing(1.25), md: theme.spacing(2.5) },
});
